import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
} from "firebase/functions"

import { app } from ".."

export const functions = getFunctions(app)
if (process.env.REACT_APP_FIREBASE_EMULATION_MODE === "EMULATION")
  connectFunctionsEmulator(functions, "localhost", 5001)

export class HttpsCallableFactory {
  constructor(private prefix: string) {}
  callFunction = <T, U>(name: string) => {
    return httpsCallable<T, U>(functions, this.prefix + "-" + name)
  }
}
